import script from "./EditNoteObservationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditNoteObservationForm.vue?vue&type=script&setup=true&lang=js"

import "./EditNoteObservationForm.vue?vue&type=style&index=0&id=d3b98e1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3b98e1c"]])

export default __exports__